import types from "cms/enums/contentsTypes.enum";
import { urlRegex } from "cms/utils/commonUtils";
export var url = {
    type: types.URL,
    label: "Url",
    regexValidation: urlRegex
};
